import React, { useState } from 'react'

import { FormattedMessage } from 'react-intl'

import formStyles from 'components/Form.css'
import ProfileStyles from './ProfileSummary.css'
import ScaledImage from 'components/ScaledImage'
import Card from 'components/Card'
import { useMediaQuery } from '@material-ui/core'
import { PlaygroundLink, User } from 'lib-core'
import { getPersonName } from 'components/PersonName'

const styles = {
  ...formStyles,
  ...ProfileStyles
}

const Statistic = ({ value, label }) => {
  return (
    <div className={styles.figure}>
      <div className={styles.figure_value}>{value ? value : '0'}</div>
      <div className={styles.figure_label}>
        <FormattedMessage id={label} />
      </div>
    </div>
  )
}

const MaybeAvatar = ({ profile: { avatar } }) => {
  if (avatar) {
    return (
      <ScaledImage
        className={styles.profilepic}
        uuid={avatar.uuid}
        w={128}
        h={128}
        crop={true}
      />
    )
  } else {
    return <div className={styles.profilepic} />
  }
}

const ProfileSummary = ({
  isMine,
  profile,
  ProfileSummaryButton = () => null
}: { isMine?: boolean, profile: User, ProfileSummaryButton?: () => void }) => {
  const [count, setCount] = useState(0)
  const onDev = () => {
    if (count > 5) {
      window.location.href = "/playground/lib/mobile/rpc/"
      return
    }
    setCount(v => v + 1)
  }
  const { bio, stats } = profile
  const displayName = getPersonName(profile)
  const mobile = useMediaQuery('(max-width:600px)');
  return (
    <Card>
      <div className={styles.topprofilebox}>
        <MaybeAvatar profile={profile} />
        <div className={styles.infobox}>
          <div className={styles.name}>
            {displayName.length > 14 && mobile
              ? `${displayName.substring(0, 14)}...`
              : displayName}          </div>
          <ProfileSummaryButton />
          <div className={styles.bio} onClick={onDev}>
            {bio ? (
              bio
            ) : (
              <FormattedMessage
                id={`profile.${isMine ? 'my' : 'their'}_short_bio_default`}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles.figures}>
        <Statistic value={stats.rep} label="profile.reputation_label" />
        <Statistic
          value={stats.followerCount}
          label="profile.followers_label"
        />
        <Statistic
          value={stats.followingCount}
          label="profile.following_label"
        />
      </div>
      <PlaygroundLink />
    </Card>
  )
}

export default ProfileSummary
